<div class="ds-beta">
    <p-table  [columns]="this.columnData" [value]="this.searchResults" [rows]="20" responsiveLayout="scroll" styleClass="p-datatable-striped"
	[(selection)]="selectedData" [paginator]="true" [loading]="!this.searchResults" (sortFunction)="sortColumn($event)" [customSort]="true">
		<ng-template pTemplate="header" let-rowData let-columns>
			<tr>
				<th class="selectColumn" id="selectColumn">
					<p-tableHeaderCheckbox i18n-ariaLabel ariaLabel="SELECT"></p-tableHeaderCheckbox>
				</th>
				<th *ngIf="addStreetDescriptionColumn" id="descriptionCol" pSortableColumn="description">
					<span i18n="Address | Address Label">Address</span>
					<p-sortIcon field="description"></p-sortIcon>
				</th>
				<th *ngIf="addOwnerNameColumn" id="ownerNameCol" pSortableColumn="OwnerName">
					<span i18n="Name | Name Label">Name</span>
					<p-sortIcon field="OwnerName"></p-sortIcon>
				</th>
				<th *ngIf="addOwnerAddressColumn" id="ownerAddressCol" pSortableColumn="OwnerAddress">
					<span i18n="Address | Address Label">Address</span>
					<p-sortIcon field="OwnerAddress"></p-sortIcon>
				</th>

				<th [id]="col.field" *ngFor="let col of columns" [ariaLabel]="col.field" [pSortableColumn]="col.field" class="SuggestionResultsTH" >
					{{col.header}}
					<p-sortIcon [field]="col.field"></p-sortIcon>
				</th> 
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-rowData let-columns="columns">
			<tr >
				<td #conditionCol *ngIf="hasCondition(rowData, conditionType.Lock)"  class="selectColumn lockedColumn" [pTooltip]="this.getTooltip(rowData)" [escape]="false">
					<icon aria-label="Locked" class="accelicons accelicons-lock-small"></icon>
				</td>
				<td *ngIf="!hasCondition(rowData, conditionType.Lock)" class="selectColumn" [pTooltip]="this.getTooltip(rowData)" [escape]="false"
					[ngClass]="{'holdColumn': hasCondition(rowData, conditionType.Hold), 'noticeColumn': hasCondition(rowData, conditionType.Notice), 'requiredColumn': hasCondition(rowData, conditionType.Required)}">
					<div class="checkboxCell">
						<p-tableCheckbox i18n-ariaLabel ariaLabel="SELECT" [value]="rowData"></p-tableCheckbox>
						<icon *ngIf="hasCondition(rowData, conditionType.Hold)" aria-label="Hold" class="accelicons accelicons-hand-small"></icon>
						<icon *ngIf="hasCondition(rowData, conditionType.Notice)" aria-label="Notice" class="accelicons accelicons-alert-small"></icon>
						<icon *ngIf="hasCondition(rowData, conditionType.Required)" aria-label="Required" class="accelicons accelicons-alert-small"></icon>
					</div>
				</td>
				<td *ngIf="addStreetDescriptionColumn">{{getRefAddressDescription(rowData)}}</td>
				<td *ngIf="addOwnerNameColumn">{{getOwnerNameDescription(rowData)}}</td>
				<td *ngIf="addOwnerAddressColumn">{{this.getOwnerAddressDescription(rowData)}}</td>
				<td *ngFor="let col of columns">{{rowData[col.field]}}</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="summary" let-rowData="rowData">
			<div style="text-align: left" i18n="Selected Items: | Search Results Summary">
				Selected Items: {{selectedData?.length}}
			</div>
		</ng-template>
		<ng-template pTemplate="emptymessage" let-columns>
			<tr>
			  <td [attr.colspan]="columns.length" i18n="No records found: | Empty Search Message">
				 No records found
			  </td>
			</tr>
		  </ng-template>
	</p-table>
	<div class="search-footer p-mt-3">
		<accela-button-secondary *ngIf="(alternateActionLabel !== '' && showAddButton)" type="button" accessButton="n" [label]="alternateActionLabel" (click)="this.altClick($event)" class="p-button-outlined p-mr-5" pRipple></accela-button-secondary>

		<accela-button-primary type="submit" value="submit"  class="createBtn" i18n i18n-label label="Select" (click)="this.submitRows()" [disabled]="(this.selectedData?.length <= 0)" pRipple></accela-button-primary>
	</div>
</div>
